<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="活动搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入活动名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button type="primary" style="margin-left: 40px;" @click="editBtn('')">添加活动</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="activityName"
            label="活动名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="activityStartTime"
            label="活动时间">
            <template slot-scope="scope">
              <span>{{scope.row.activityStartTime+'-'+scope.row.activityEndTime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1" class="mt-green">开启</span>
              <span v-else class="mt-red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="210"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="getRecordBtn(scope.row.id)" type="text" size="small">领取记录</el-button>
              <el-button @click="toManageBtn(scope.row.id)" type="text" size="small">优惠券管理</el-button>
              <el-button @click="editBtn(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
              <el-button @click="erwBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">小程序码</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <!-- 小程序码弹窗 -->
    <el-dialog
      title="小程序码"
      :visible.sync="erwImgShow"
      size="960px">
      <el-image
        style="width: 240px;margin:0 auto;display: block;"
        :src="erwImg"
        :preview-src-list="[erwImg]"
        fit="contain"></el-image>
    </el-dialog>
  </div>
</template>

<script>
import { queryCouponActivityCenterPageList, removeCouponActivityCenterById, getCouponActivityQrCode } from '@/api/coupon'
export default {
  name: 'CouponCenter',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 小程序码弹窗
      erwImgShow:false,
      erwImg:''
    }
  },
  mounted () {
    this.getInfoList()
  },
  methods: {
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryCouponActivityCenterPageList({ activityName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 跳转领取记录页面
    getRecordBtn (infoId) {
      this.$router.push({path: '/coupon_get_record', query: {couponActivityCenterId: infoId}})
    },
    // 跳转优惠券管理页面
    toManageBtn (infoId) {
      this.$router.push({path: '/coupon_center_manage', query: {dataId: infoId}})
    },
    /* 编辑 */
    editBtn (infoId) {
      this.$router.push({path: '/coupon_center_add', query: {dataId: infoId}})
    },
     /* 小程序码 */
    erwBtn (infoId){
      let that = this
      that.erwImg = '';
      that.fullscreenLoading = true
      getCouponActivityQrCode({ id: infoId}).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          that.erwImg = res.data.fileUrl;
          that.erwImgShow = true;
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg)
        }
      })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeCouponActivityCenterById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/coupon/CouponCenter.vue